import { metrics } from './metrics/index';
import metricsProvider from 'metrics-provider'; // eslint-disable-line import-x/no-unresolved
import * as middleware from './middleware';

const setup = (config) => metrics.use(metricsProvider(config));

export { metrics, setup, middleware };



// WEBPACK FOOTER //
// ./src/index.js